<nb-card class="invitation-history-dialog">
  <nb-card-header class="history-header">
    <div>
      <span class="tw-font-semibold">Invitation history</span>
      <div class="tw-text-xs tw-text-slate-500 tw-mt-0.5">Bulk invites for {{ currentEvent?.name ?? 'this event' }}</div>
    </div>
    <div class="tw-flex tw-items-center tw-gap-1">
      <button nbButton ghost size="small" (click)="loadJobs()" aria-label="Refresh">
        <nb-icon icon="refresh-outline"></nb-icon>
      </button>
      <button nbButton ghost size="small" (click)="close()" aria-label="Close">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>

  <nb-card-body class="invitation-history-body">
    <div *ngIf="loading" class="tw-py-6 tw-text-center">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      <p class="tw-mt-2 tw-text-xs tw-text-slate-500">Loading…</p>
    </div>

    <p *ngIf="!currentEvent?.id && !loading" class="tw-py-8 tw-text-center tw-text-sm tw-text-slate-500">
      No event selected.
    </p>

    <p *ngIf="currentEvent?.id && !loading && jobs.length === 0" class="tw-py-8 tw-text-center tw-text-sm tw-text-slate-500">
      No invitation jobs in the last 30 days for this event.
    </p>

    <ul *ngIf="!loading && jobs.length > 0" class="tw-list-none tw-p-0 tw-m-0 tw-flex tw-flex-col tw-gap-3">
      <li
        *ngFor="let job of jobs"
        class="job-card"
        [class.job-card--in]="isInbound(job)"
        [class.job-card--out]="!isInbound(job)"
      >
        <div class="tw-flex tw-justify-between tw-gap-2 tw-items-start">
          <div class="tw-min-w-0 tw-flex-1">
            <div class="route-badges">
              <span
                class="route-badge"
                [class.route-badge--in]="isInbound(job)"
                [class.route-badge--out]="!isInbound(job)"
              >
                {{ isInbound(job) ? 'Into this event' : 'Out of this event' }}
              </span>
              <span class="channel-badge">{{ channelLabel(jobSendMethod(job)) }}</span>
            </div>

            <div
              class="route-heading"
              [class.route-heading--in]="isInbound(job)"
              [class.route-heading--out]="!isInbound(job)"
              [attr.aria-label]="isInbound(job) ? 'Invites from ' + peerEventName(job) : 'Invites to ' + peerEventName(job)"
            >
              <mat-icon class="route-arrow" aria-hidden="true">{{ directionIcon(job) }}</mat-icon>
              <span class="route-event-name">{{ peerEventName(job) }}</span>
            </div>
            <p class="route-personas">
              {{ job.from_form.name }}
              <span class="route-personas-sep" aria-hidden="true">→</span>
              {{ job.to_form.name }}
            </p>
          </div>

          <span class="tw-text-xs tw-font-medium tw-px-2 tw-py-0.5 tw-rounded-full tw-shrink-0" [ngClass]="statusClass(job)">
            {{ statusLabel(job) }}
          </span>
        </div>

        <p *ngIf="job.status === 'failed' && job.error_message" class="job-error tw-mt-2">
          {{ job.error_message }}
        </p>

        <div class="tw-mt-2 tw-text-xs tw-text-slate-600">
          {{ progressCaption(job) }} — {{ progressPercent(job) }}%
          <span *ngIf="effectiveTotal(job) > 0" class="tw-text-slate-400"> ({{ job.invite_count || 0 }}/{{ effectiveTotal(job) }})</span>
        </div>
        <div class="tw-h-1 tw-bg-slate-200 tw-rounded tw-mt-1 tw-overflow-hidden">
          <div
            class="tw-h-full tw-progress-bar"
            [class.tw-progress-bar--in]="isInbound(job)"
            [class.tw-progress-bar--out]="!isInbound(job)"
            [style.width.%]="progressPercent(job)"
          ></div>
        </div>
        <div class="tw-mt-2 tw-text-xs tw-text-slate-500">
          Requested {{ job.requested_count }} · Invited {{ job.invite_count }} · Delivered {{ job.delivered_count }}
        </div>
      </li>
    </ul>
  </nb-card-body>
</nb-card>
